import {
    BaseError,
} from 'wanderu-utils';

export default class NoResultsError extends BaseError {
    constructor() {
        super('No results found');
    }
}
